module.exports = __webpack_public_path__ + "img/icon_map_4_on_100.6bc32c24.png";